import React from "react";
import Slider from "react-slick";
import "./Products.scss";
import Product from "./Product/Product";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";

const Products = ({ products, innerPage, headingText }) => {
  const naviagte = useNavigate();

  const sliderSettings = {
    dots: false,
    infinite: true,
    prevArrow: <button className="slick-prev ">Previous</button>,
    nextArrow: <button className="slick-next">Next</button>,

    speed: 500,
    slidesToShow: 5, // Number of cards shown at a time
    slidesToScroll: 1,
    autoplay: false, // Enable auto-scrolling
    autoplaySpeed: 2000, // Number of cards scrolled at a time
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <div className="products-container">
      {!innerPage && (
        <div className=" flex justify-between items-center">
          <div className="sec-heading text-[#C51414] text-3xl  font-extrabold   ">
            {headingText}
          </div>
          <div
            className=" uppercase  bg-[#C51414]  h-fit py-1 md:py-2 px-4 md:px-8 rounded-md font-bold text-white flex justify-center items-center relative -top-3 cursor-pointer "
            onClick={() => naviagte("/category/1")}
          >
            view all{" "}
            <div className=" md:text-2xl relative top-1 px-2">
              <ion-icon name="arrow-forward-circle-outline"></ion-icon>
            </div>
          </div>
        </div>
      )}
      <Slider
        {...sliderSettings}
        className={`products ${innerPage ? "innerPage" : ""}`}
      >
        {products?.map((item) => (
          <div className="  " key={item?._id}>
            <Product
              id={item?._id}
              data={item?.categories}
              name={item?.name}
              images={item?.images}
              price={item?.price}
              product={item}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Products;
